import React, { useState, useRef, useEffect } from 'react'
import { Button, Form, Modal, Checkbox, Input, Space, TableColumnsType, Table, Dropdown, message, DatePicker, Select } from 'antd'
import { CloseIco, DateIco, ModalCloseIco, PensilIco, PlusIco, RefreshIco } from '../../../modules/CustomIcons'

import './index.scss'
import { OWNACCOUNT } from 'constants/constants'
import SvgRectPlus from 'assets/images/icons/SvgRectPlus'
import { t } from 'i18next'
import SortableColumn from 'components/Table/ColumnSort'

import { DownOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import type { InputRef, TableColumnType, MenuProps, DatePickerProps } from 'antd';
import type { FilterDropdownProps } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import CustomTooltip from '../../components/Tooltip'
import moment from 'moment'
import DocumentsSearchableColumn from 'components/Table/DocumentsColumnSearch'
interface DataType {
    key: string;
    docId: React.Key;
    docName: string;
    docNumAbsent: boolean;
    docNum: string;
    docDate: string;
    docNote: string;
    docNameLabel:string
}




const DocumentsPreviewModal: React.FC<ModalProps> = ({
    children,
    onOk,
    visible,
    title,
    onCancel,
    className,
    width,
    height,
    page,
    okText,
    footer,
    data
}) => {
    const [buttonClicked, setButtonClicked] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [documentIdCount, setDocumentIdCount] = useState(5);
    const searchInput = useRef<InputRef>(null);
    const [form] = Form.useForm()
    const [filtereValues, setFilteredValues] = useState({  "docNum": "", "docDate": "", "docNote": '',"docNameLabel":""})
    const [documentsDataoriginal,setdocumentsDataoriginal] = useState(data)
    const [documentsDataoriginalSort,setdocumentsDataoriginalSort] = useState(data)
  
    const [documentsData, setDocumentsData] = useState(data);
    useEffect(()=>{
        console.log(data)
        if(data !== undefined)
        {data?.map((row,index)=>{
            
             data[index].key =index+1
             return data
        })
        setDocumentsData(data)
        setdocumentsDataoriginal(data)
        setdocumentsDataoriginalSort(data)
    }
},[data])

    const handleSearch = (
        selectedKeys: string[],
        confirm: FilterDropdownProps['confirm'],
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex: DataIndex): TableColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={''}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Axtar
                    </Button>
                    {/* <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Sıfırla
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            setSearchText((selectedKeys as string[])[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filterlə
                    </Button> */}
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        Bağla
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const handleMenuClick: MenuProps['onClick'] = (e) => {
        console.log('click', e);
    };

    const items = [
        {
            label: 'Contract',
            value: 'CNT',
        },
        {
            label: 'Invoice',
            value: 'INV',
        },
        {
            label: 'Purchase Order',
            value: 'PO',
        },
        {
            label: 'Debit Note',
            value: 'DN',
        },
        {
            label: 'GB',
            value: 'GB',
        },
        {
            label: 'Letter',
            value: 'LETTER',
        },
        {
            label: "Shareholders' resolution",
            value: 'SHAREHOLD.RESOL',
        },
        {
            label: "Court's decision",
            value: 'COURT.DECIS',
        },
    ];

    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    const handleDocNameChange = (e: any) => {
        console.log(e, 'selected');
    }
    const handleFilterColumn = (e: any, column: string) => {

        let newfiltereValues = filtereValues;
    console.log(newfiltereValues)
        if (column === 'docNameLabel') {
            newfiltereValues.docNameLabel = e.target.value?.toLowerCase()
            newfiltereValues.docDate = ''
            newfiltereValues.docNum = ''
            newfiltereValues.docNote = ''
            setFilteredValues(newfiltereValues)
          }
        if (column === 'docNum') {
          newfiltereValues.docNum = e.target.value?.toLowerCase()
          newfiltereValues.docDate = ''
          newfiltereValues.docNameLabel = ''
          newfiltereValues.docNote = ''
          setFilteredValues(newfiltereValues)
        }
    
        if (column === 'docDate') {
          newfiltereValues.docDate = e.target.value?.toLowerCase()
          newfiltereValues.docNum = ''
          newfiltereValues.docNote = ''
          newfiltereValues.docNameLabel = ''
          
          setFilteredValues(newfiltereValues)
        }
    
        if (column === 'docNote') {
          newfiltereValues.docNote = e.target.value?.toLowerCase()
          newfiltereValues.docDate = ''
          newfiltereValues.docNum = ''
          newfiltereValues.docNameLabel = ''

          setFilteredValues(newfiltereValues)
        }
    
      
        if (data && filtereValues) {
    
            let filteredData: any;
              console.log(data)
            
            filteredData = documentsDataoriginal?.filter((row:any)=>
                (filtereValues["docNameLabel"] !== "" ? (row.docNameLabel !== '' ? row.docNameLabel.toLowerCase().includes(filtereValues["docNameLabel"]): null) : row)                        
            && (filtereValues["docNum"] !== "" ? (row.docNum !== '' ? row.docNum.toLowerCase().includes(filtereValues["docNum"]): null) : row)
            && (filtereValues["docDate"] !== "" ? (row.docDate !== '' ? row.docDate.toLowerCase().includes(filtereValues["docDate"]): null) : row)
            && (filtereValues["docNote"] !== "" ? (row.docNote !== '' ? row.docNote.toLowerCase().includes(filtereValues["docNote"]): null) : row)
          
          )
          console.log(filteredData)
              setDocumentsData(old_data => filteredData);
              
         
    
          // setTableListForSortOriginal(old => filteredData)
          // setPagination({
          //   ...pagination,
          //   current: 1
          // })
    
        }
    }
// useEffect(()=>{
//    console.log(data) 
// },data)
    const columns: TableColumnsType<DataType> = [
        {
            title: (
                <div className='foregn-table-key'>
                    <SortableColumn 
                    data={documentsData}
                    setData={(e)=>{setDocumentsData(e);setdocumentsDataoriginal(e)}}
                    dataOriginal={documentsDataoriginalSort}
                    type={"number"}
                    parameter={"docId"}
                    />
                    <span>№</span>
                </div>
            ),
            dataIndex: 'key',
            key: 'key',
            ellipsis:false,
            width: '5%',
            // sorter: (a, b) => Number(a.docId) - Number(b.docId),
            // showSorterTooltip: false,
        },
        {
            title:
                (
                    <div className='foregn-table-key'>
                    <SortableColumn 
                     data={documentsData}
                     setData={(e)=>{setDocumentsData(e);setdocumentsDataoriginal(e)}}
                     dataOriginal={documentsDataoriginalSort}
                     type={"string"}
                     parameter={"docName"}
                    />
                    <Form form={form} style={{ width: '100%' }}>
                    <DocumentsSearchableColumn
                        large
                        title={t("modal.documentname")}
                        form={form}
                        name={'docNameLabel'}
                        filter={'searchfilter'}
                        onChange={(event: any) =>
                            handleFilterColumn(event,'docNameLabel')
                            
                           
                        }
                        buttonClicked={buttonClicked}
                        page={"salaryList"}
                    />
                </Form>
                </div>
                ),
            dataIndex: 'docNameLabel',
            key: 'docNameLabel',
            width: '20%',
          
            // sorter: (a, b) => a.docNameLabel.length - b.docNameLabel.length,
            
        },
        {
            title: (
                <div className='foregn-table-key'>
                    {/* <SortableColumn /> */}
                    <span>{t("modal.noNumber")}</span>
                </div>
            ),
            dataIndex: 'docNumAbsent',
            key: 'docNumAbsent',
            render(checked, record, index) {
                let str = typeof checked
                
                return <div style={{ display: 'flex' }}>
                    <input type='checkbox' className='docNumAbsent-checkbox' defaultChecked={str === 'boolean' ? checked : (checked==='false' ? false :true )} style={{ margin: '0 auto' }} disabled={true} />
                </div>
            },
            width: '10%',
        },
        {
            title: (
                <div className='foregn-table-key'>
                    <SortableColumn
                    data={documentsData}
                    setData={(e)=>{setDocumentsData(e);setdocumentsDataoriginal(e)}}
                    dataOriginal={documentsDataoriginalSort}
                    type={"string"}
                    parameter={"docNum"}
                    />
                    <Form form={form} style={{ width: '100%' }}>
                        <DocumentsSearchableColumn
                            large
                            title={t("modal.number")}
                            form={form}
                            name={'docNum'}
                            filter={'searchfilter'}
                            onChange={(event: any) =>
                                handleFilterColumn(event,'docNum')
                                
                               
                            }
                            buttonClicked={buttonClicked}
                            page={"salaryList"}
                        />
                    </Form>
                </div>
            ),
            dataIndex: 'docNum',
            key: 'docNum',
            width: '20%',
            // sorter: (a, b) => a.docName.length - b.docName.length,
        
            render:(text,record)=>
                {
                    if(text.length > 25){
                        return <CustomTooltip title={text}>
                            {text}
                        </CustomTooltip>
                    }else{
                        return text
                    }
                }
        },
        {
            title: (
                <div className='foregn-table-key date_column'>
                    
                <SortableColumn
                data={documentsData}
                setData={(e)=>{setDocumentsData(e);setdocumentsDataoriginal(e)}}
                dataOriginal={documentsDataoriginalSort}
                type={"date"}
                pagetransfer={page}
                parameter={"docDate"}
                documentsDate={true}

                />
                <Form form={form} style={{ width: '100%' }}>
                    <DocumentsSearchableColumn
                        large
                        title={t("modal.date")}
                        form={form}
                        name={'docDate'}
                        filter={'searchfilter'}
                        onChange={(event: any) =>
                            handleFilterColumn(event,'docDate')
                        }
                        buttonClicked={buttonClicked}
                        page={"salaryList"}
                    />
                </Form>
            </div>
            ),
            dataIndex: 'docDate',
            key: 'docDate',
            width: '15%',
            // sorter: (a, b) => new Date(a.docDate).getTime() - new Date(b.docDate).getTime(),
          
            render:(text,record)=>
                {
                 return moment(text).format('DD.MM.YYYY')
                }
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center' }} className='note-column-documenstPreview'>
                    <Form form={form} style={{ width: '100%' }}>
                        <DocumentsSearchableColumn
                            large
                            title={t("modal.note")}
                            form={form}
                            name={'docNote'}
                            filter={'searchfilter'}
                            onChange={(event: any) =>
                                handleFilterColumn(event,'docNote')
                                
                               
                            }
                            buttonClicked={buttonClicked}
                            page={"salaryList"}
                        />
                    </Form>
                </div>
            ),
            dataIndex: 'docNote',
            key: 'docNote',
            width: '30%',
            
            ellipsis: true,
            render:(text,record)=>
            {
                if(text.length > 25){
                    return <CustomTooltip title={text}>
                        {text}
                    </CustomTooltip>
                }else{
                    return text
                }
            }
                
 
        },
    ];

    type DataIndex = keyof DataType;

    const newDefaultRow = {
        key: documentIdCount.toString(),
        docId: documentIdCount.toString(),
        docName: '',
        docNumAbsent: false,
        docNum: '',
        docDate: '',
        docNote: '',
    };

    // const data: DataType[] = [
    //     {
    //         key: '1',
    //         docId: '1',
    //         docName: 'Contract',
    //         docNumAbsent: true,
    //         docNum: '4544151532',
    //         docDate: '2020-02-12',
    //         docNote: 'This is a uaua',
    //     },
    //     {
    //         key: '2',
    //         docId: '2',
    //         docName: 'Shareholders resolution',
    //         docNumAbsent: false,
    //         docNum: '521515155',
    //         docDate: '2020-12-22',
    //         docNote: 'This is a note',
    //     },
    //     {
    //         key: '3',
    //         docId: '3',
    //         docName: 'Contract',
    //         docNumAbsent: true,
    //         docNum: '11212121',
    //         docDate: '2020-12-12',
    //         docNote: 'This is a docNote',
    //     },
    //     {
    //         key: '4',
    //         docId: '4',
    //         docName: 'Shareholders resolution',
    //         docNumAbsent: false,
    //         docNum: '252551551',
    //         docDate: '1992-11-03',
    //         docNote: 'resolution is a docNote',
    //     },
    // ];

    const onDateChange: DatePickerProps['onChange'] = (date, dateString) => {
        console.log(date, dateString);
    };

    const onBackClick = () => {
        onCancel();
    }




    return (
        <div className="documentsModalMain">
            <Modal
                okText={okText}
                okButtonProps={{ style: { background: '#015CD1' } }}
                title={title}
                centered
                open={visible}
                onOk={onOk}
                closeIcon={<ModalCloseIco />}
                onCancel={onCancel}
                okType="primary"
                width={width}
                height={height}
                className={className}
                cancelButtonProps={{ style: { display: 'none' } }}
                footer={null}


            >
                <main className='documentsModalMain'>
                    <Table
                        className='table-row-background'
                        columns={columns}
                        dataSource={documentsData}
                        showSorterTooltip={false}
                        pagination={false}
                        size='small'
                        
                    />

                </main>
                <footer className='documentsModalFooter'>
                    <div className="documentsModalFooterLeft">
                    </div>
                    <div className="documentsModalFooterRight">
                        <Button
                            size={'large'}
                            htmlType="submit"
                            className="cancel_btn light-button btn flex align_center justify_center"
                            onClick={onCancel}
                        >
                           {t("templates.back")}
                        </Button>
                    </div>
                </footer>
            </Modal>
        </div>
    )
}

export default DocumentsPreviewModal